import { useMemo } from 'react';
import { usePage } from '~/templates/pages';

export const useGABreadcrumb = () => {
    const { breadcrumb } = usePage();

    const gaBreadcrumb = useMemo(() => {
        if (!breadcrumb?.items) return '';

        // Skip the first item (usually Home) and the last item (current product)
        const [, ...categories] = breadcrumb.items;

        return categories
            .slice(0, -1)
            .map((category) => `${category.title}#${category.title}`)
            .join(';');
    }, [breadcrumb]);

    return gaBreadcrumb;
};
